import {
  AdjustmentsIcon,
  ArrowSmRightIcon,
  CheckIcon,
  ChevronDoubleDownIcon,
  ChevronDoubleRightIcon,
  InformationCircleIcon,
  LockClosedIcon,
  LockOpenIcon,
  PencilIcon,
  PlusIcon,
  SearchIcon,
  StarIcon,
  TrashIcon,
  TrendingUpIcon,
  UserAddIcon,
} from "@heroicons/react/outline";
import { ExclamationIcon, XIcon } from "@heroicons/react/solid";
import {
  ArrowLeft,
  ArrowRight,
  Asterisk01,
  BarChartSquare01,
  BatteryMid,
  Calendar,
  CalendarCheck02,
  CalendarPlus02,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Clipboard,
  ClockRewind,
  Compass03,
  DotsHorizontal,
  Edit05,
  Expand01,
  FileSearch01,
  FilterFunnel01,
  Hand,
  HeartHand,
  Home02,
  LayoutGrid01,
  LayoutRight,
  Lightbulb02,
  Lightning02,
  LineChartUp01,
  LinkExternal01,
  MessageChatCircle,
  MessageSquare02,
  Microphone01,
  MicrophoneOff01,
  Minimize01,
  NotificationBox,
  PauseCircle,
  PlusCircle,
  RefreshCcw02,
  Rocket02,
  Scales02,
  Shield01,
  Sliders04,
  Star04,
  Target05,
  ThumbsDown,
  ThumbsUp,
  Trophy01,
  Upload04,
  User01,
  Users01,
  Zap,
} from "@untitled-ui/icons-react";
import { SVGProps } from "react";
import { IconType } from "react-icons";
import { BiCommentAdd } from "react-icons/bi";
import { FaArrowDown, FaArrowUp, FaEquals } from "react-icons/fa6";
import { GoArrowDownRight, GoArrowUpRight } from "react-icons/go";
import {
  HiDotsHorizontal,
  HiOutlineEye,
  HiOutlineEyeOff,
  HiOutlineSwitchHorizontal,
} from "react-icons/hi";
import { IoMdExit, IoMdHappy } from "react-icons/io";
import { LiaUserEditSolid } from "react-icons/lia";
import {
  MdCheckBoxOutlineBlank,
  MdContentCopy,
  MdFilterAlt,
  MdOutlineCancel,
  MdOutlineChat,
  MdOutlineCheckBox,
  MdOutlineDragIndicator,
  MdRadioButtonChecked,
  MdRadioButtonUnchecked,
} from "react-icons/md";
import { PiTextAlignLeftBold } from "react-icons/pi";
import { RiTeamLine } from "react-icons/ri";
import { RxDotFilled } from "react-icons/rx";
import { TbBuilding, TbLayoutSidebarFilled } from "react-icons/tb";

export const TopicflowIconMap = {
  actionItem: MdCheckBoxOutlineBlank,
  adjustments: AdjustmentsIcon,
  ai: Star04,
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  assessment: BarChartSquare01,
  asterisk: Asterisk01,
  calendarCheck: CalendarCheck02,
  calendarPlus: CalendarPlus02,
  chat: MdOutlineChat,
  chatAdd: BiCommentAdd,
  check: CheckIcon,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronDown: ChevronDown,
  chevronDownDouble: ChevronDoubleDownIcon,
  chevronRightDouble: ChevronDoubleRightIcon,
  chevronUp: ChevronUp,
  close: XIcon,
  copy: MdContentCopy,
  deactivated: MdOutlineCancel,
  dot: RxDotFilled,
  downArrow: FaArrowDown,
  downRightArrow: GoArrowDownRight,
  drag: MdOutlineDragIndicator,
  edit: PencilIcon,
  equals: FaEquals,
  exit: IoMdExit,
  collapseArrows: Minimize01,
  expandArrows: Expand01,
  explorer: Compass03,
  externalLink: LinkExternal01,
  eye: HiOutlineEye,
  eyeOff: HiOutlineEyeOff,
  feedback: Upload04,
  fileSearch: FileSearch01,
  filter: MdFilterAlt,
  filterFunnel: FilterFunnel01,
  goal: Target05,
  home: Home02,
  horizontalDots: DotsHorizontal,
  info: InformationCircleIcon,
  kpi: TrendingUpIcon,
  lock: LockOpenIcon,
  lockClosed: LockClosedIcon,
  meeting: Calendar,

  MessageSquare02: MessageSquare02,
  microphone: Microphone01,
  microphoneOff: MicrophoneOff01,
  multichoice: MdOutlineCheckBox,
  nps: IoMdHappy,
  organization: TbBuilding,
  pauseCircle: PauseCircle,
  pencilSquare: Edit05,
  plus: PlusIcon,
  plusCircle: PlusCircle,
  previous: ClockRewind,
  program: LayoutGrid01,
  radioButtonChecked: MdRadioButtonChecked,
  radioButtonUnchecked: MdRadioButtonUnchecked,
  range: HiDotsHorizontal,
  recognition: Trophy01,
  refresh: RefreshCcw02,
  reporting: LineChartUp01,
  rightArrow: ArrowSmRightIcon,
  search: SearchIcon,
  sidebar: TbLayoutSidebarFilled,
  toggleSidebar: LayoutRight,
  star: StarIcon,
  survey: Clipboard,
  switch: HiOutlineSwitchHorizontal,
  team: RiTeamLine,
  text: PiTextAlignLeftBold,
  threads: MessageSquare02,
  thumbsDown: ThumbsDown,
  thumbsUp: ThumbsUp,
  trash: TrashIcon,
  today: NotificationBox,
  upArrow: FaArrowUp,
  upRightArrow: GoArrowUpRight,
  user: User01,
  userAdd: UserAddIcon,
  userEdit: LiaUserEditSolid,
  users: Users01,
  warning: ExclamationIcon,

  // Coaching dimension icons (keyed by dimension name)
  "Career Growth": Rocket02,
  "Blockers & Support": Lightning02,
  "Blockers Support": Lightning02,
  "Workload Balance": Scales02,
  "Psychological Safety": Shield01,
  "Feedback & Recognition": Trophy01,
  "Feedback Recognition": Trophy01,
  "Decision Making": Zap,
  "Autonomy & Delegation": Hand,
  "Autonomy Delegation": Hand,
  "Energy Alignment": BatteryMid,
  "Frequency Health": Calendar,
  "Meeting Structure": Sliders04,
  "Talk Ratio": MessageChatCircle,
  "Personal Connection": HeartHand,
  "Expectations Tracker": Target05,
  "Team Dynamics": Users01,
  coachingDefault: Lightbulb02,
};

export type TopicflowIconType = keyof typeof TopicflowIconMap;

export const getTopicflowIcon = (
  type: TopicflowIconType,
): ((props: SVGProps<SVGSVGElement>) => React.JSX.Element) | IconType => {
  if (type in TopicflowIconMap) {
    return TopicflowIconMap[type];
  }
  throw new Error(`Unknown icon type: ${type}`);
};
